import { render } from "./productOverviewLayout.vue?vue&type=template&id=dbeb1382&scoped=true&ts=true"
import script from "./productOverviewLayout.vue?vue&type=script&lang=ts"
export * from "./productOverviewLayout.vue?vue&type=script&lang=ts"

import "./productOverviewLayout.vue?vue&type=style&index=0&id=dbeb1382&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbeb1382"]])

export default __exports__